import { Injectable } from '@angular/core';

export abstract class DocService {
  openFlowHelp() {
    window.open('/api/docs/flowengine', '_blank');
  }
  abstract openRendererHelp(): void;
}

@Injectable({
  providedIn: 'root',
})
export class DhlDocService extends DocService {
  openRendererHelp() {
    window.open('/api/docs/renderer-dhl', '_blank');
  }
}

@Injectable({
  providedIn: 'root',
})
export class MaterialDocService extends DocService {
  openRendererHelp() {
    window.open('/api/docs/renderer-material', '_blank');
  }
}
